export const ABSOLUTE = 'absolute';
